// src/lib/menuI18n.js — textes de l'interface publique (FR / EN / AR)
export const LANGS = { fr: 'Français', en: 'English', ar: 'العربية' }
export const textDir = (lang) => (lang === 'ar' ? 'rtl' : 'ltr')

export const UI = {
  fr: {
    search: 'Rechercher un plat…', popularTitle: 'Nos plats populaires', seeAll: 'Voir tout', popular: 'Populaires',
    popularBadge: 'Populaire', viewOrder: 'Voir ma commande', articles: (n) => `${n} article${n > 1 ? 's' : ''}`,
    table: 'Table', tabMenu: 'Menu', tabWaiter: 'Appeler serveur', tabBill: "Demander l'addition", tabMore: 'Plus',
    cart: 'Ma commande', clear: 'Vider', empty: 'Votre panier est vide.', tableNo: 'Numéro de table',
    yourName: 'Votre prénom (facultatif)', remark: 'Remarque pour la commande', total: 'Total',
    send: 'Envoyer la commande', sendWhatsapp: 'Envoyer sur WhatsApp', add: 'Ajouter',
    itemNote: 'Une précision ? (sans oignon, bien cuit…)', noResults: 'Aucun plat ne correspond à votre recherche.',
    noDishes: 'Aucun plat pour le moment.', added: 'ajouté', waiterSent: 'Le serveur arrive tout de suite',
    billSent: "L'addition arrive", alreadySent: 'Demande déjà envoyée, un instant…',
    previewOnly: 'Disponible sur le menu publié', error: 'Une erreur est survenue. Réessayez.',
    orderNo: 'Commande n°', orderReady: 'Commande prête', showWaiter: 'Montrez cet écran au serveur pour passer commande.',
    whatsappOpened: 'Votre commande a été ouverte dans WhatsApp. Appuyez sur Envoyer pour la confirmer.',
    backToMenu: 'Retour au menu', info: 'Informations', call: 'Appeler', hours: 'Horaires', wifi: 'Wi-Fi',
    language: 'Langue', askTableTitle: 'Quelle est votre table ?', confirm: 'Confirmer', close: 'Fermer',
    follow: 'Suivre', statusNew: 'Commande reçue', statusPreparing: 'En préparation', statusReady: 'Prête !',
    statusDone: 'Servie', statusCancelled: 'Annulée',
  },
  en: {
    search: 'Search a dish…', popularTitle: 'Our popular dishes', seeAll: 'See all', popular: 'Popular',
    popularBadge: 'Popular', viewOrder: 'View my order', articles: (n) => `${n} item${n > 1 ? 's' : ''}`,
    table: 'Table', tabMenu: 'Menu', tabWaiter: 'Call waiter', tabBill: 'Ask for the bill', tabMore: 'More',
    cart: 'My order', clear: 'Clear', empty: 'Your cart is empty.', tableNo: 'Table number',
    yourName: 'Your first name (optional)', remark: 'Note for the order', total: 'Total',
    send: 'Place order', sendWhatsapp: 'Send on WhatsApp', add: 'Add',
    itemNote: 'Any request? (no onions, well done…)', noResults: 'No dish matches your search.',
    noDishes: 'No dishes yet.', added: 'added', waiterSent: 'A waiter is on the way',
    billSent: 'The bill is coming', alreadySent: 'Request already sent, one moment…',
    previewOnly: 'Available on the published menu', error: 'Something went wrong. Please retry.',
    orderNo: 'Order #', orderReady: 'Order ready', showWaiter: 'Show this screen to the waiter to place your order.',
    whatsappOpened: 'Your order was opened in WhatsApp. Press Send to confirm it.',
    backToMenu: 'Back to menu', info: 'Information', call: 'Call', hours: 'Opening hours', wifi: 'Wi-Fi',
    language: 'Language', askTableTitle: 'What is your table number?', confirm: 'Confirm', close: 'Close',
    follow: 'Track', statusNew: 'Order received', statusPreparing: 'Being prepared', statusReady: 'Ready!',
    statusDone: 'Served', statusCancelled: 'Cancelled',
  },
  ar: {
    search: 'ابحث عن طبق…', popularTitle: 'أطباقنا الأكثر طلباً', seeAll: 'عرض الكل', popular: 'الأكثر طلباً',
    popularBadge: 'شائع', viewOrder: 'عرض طلبي', articles: (n) => `${n} عناصر`,
    table: 'طاولة', tabMenu: 'القائمة', tabWaiter: 'نداء النادل', tabBill: 'طلب الفاتورة', tabMore: 'المزيد',
    cart: 'طلبي', clear: 'إفراغ', empty: 'سلتك فارغة.', tableNo: 'رقم الطاولة',
    yourName: 'اسمك (اختياري)', remark: 'ملاحظة على الطلب', total: 'المجموع',
    send: 'إرسال الطلب', sendWhatsapp: 'إرسال عبر واتساب', add: 'إضافة',
    itemNote: 'ملاحظة؟ (بدون بصل…)', noResults: 'لا توجد أطباق مطابقة لبحثك.',
    noDishes: 'لا توجد أطباق حالياً.', added: 'تمت الإضافة', waiterSent: 'النادل في الطريق',
    billSent: 'الفاتورة في الطريق', alreadySent: 'تم إرسال الطلب، لحظة…',
    previewOnly: 'متاح في القائمة المنشورة', error: 'حدث خطأ، حاول مجدداً.',
    orderNo: 'طلب رقم ', orderReady: 'الطلب جاهز', showWaiter: 'أظهر هذه الشاشة للنادل لإتمام الطلب.',
    whatsappOpened: 'تم فتح طلبك في واتساب. اضغط إرسال لتأكيده.',
    backToMenu: 'العودة للقائمة', info: 'معلومات', call: 'اتصال', hours: 'ساعات العمل', wifi: 'الواي فاي',
    language: 'اللغة', askTableTitle: 'ما رقم طاولتك؟', confirm: 'تأكيد', close: 'إغلاق',
    follow: 'تتبع', statusNew: 'تم استلام الطلب', statusPreparing: 'قيد التحضير', statusReady: 'جاهز!',
    statusDone: 'تم التقديم', statusCancelled: 'ملغى',
  },
}